import React, { useState } from "react";
import { AiFillWallet } from "react-icons/ai";
import { FaMoneyBillWave } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import { MdVolunteerActivism } from "react-icons/md";
import binance from "../../assets/payIcon/icon_binance.png";
import bitcoin from "../../assets/payIcon/icon_bitcoin.png";
import dogecoin from "../../assets/payIcon/icon_dogecoin.png";
import tron from "../../assets/payIcon/icon_tron.png";
import chartImg from "../../assets/todayChart.png";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";
import CustomLink from "../../components/Link";
import SectionCommonTable from "../../components/SectionCommonTable";
import { ToastSuccess } from "../../components/ToastNotification";
import AutoPoolTable from "./AutoPoolTable";
import BalanceTable from "./BalanceTable";
import HomeCard from "./Home.Card";
import LevelIncomTable from "./LevelIncomTable";
import MyTopupTable from "./MyTopupTable";
import TeamTopupTable from "./TeamTopupTable";
const chart = [
  {
    id: "seridsd",
    level: "Direct",
    earn: "$15,548",
    color: "#eb8153",
  },
  {
    id: "d7s4f4",
    level: "Matching",
    earn: "$17,548",
    color: "#4441de",
  },
  {
    id: "fd7f5sf5",
    level: "ROI",
    earn: "$20,548",
    color: "#60c695",
  },
];
const HomePage = () => {
  const [inputVal, setInputVal] = useState({
    rightVal: "http://www.mlmpoint.org",
    leftVal: "http://www.mlmpoint.org",
  });
  const copyToClipboard = (type) =>{
    if(type === "left"){
      navigator.clipboard.writeText(inputVal.leftVal);
      ToastSuccess("Text copied")
    }else if(type === "right"){
      navigator.clipboard.writeText(inputVal.rightVal);
      ToastSuccess("Text copied")
    }
  }
  return (
    <div className="mono_homPage_wrapper">
      <div className="mono_section_title">
        <h2>Dashboard</h2>
      </div>
      <div className="nono_dash_content card_row">
        <HomeCard
          cardName="My Profile"
          cardValue="mn75485d1"
          icon={<FiUser style={{ backgroundColor: "#348fe2" }} />}
          linkText="view details"
        />
        <HomeCard
          cardName="My Wallet"
          cardValue="0.00 TRX"
          icon={<AiFillWallet style={{ backgroundColor: "#49b6d6" }} />}
          linkText="view details"
        />
        <HomeCard
          cardName="Activation Wallet"
          cardValue="0.00 TRX"
          icon={<MdVolunteerActivism style={{ backgroundColor: "#f59c1a" }} />}
          linkText="view details"
        />
        <HomeCard
          cardName="Withdraw"
          cardValue="0.00 TRX"
          icon={<FaMoneyBillWave style={{ backgroundColor: "#ff5b57" }} />}
          linkText="view details"
        />
      </div>
      {/* refer link copy section */}
      <div className="mono_link_copy_section card_row">
        <CardLayout>
          <form>
            <div className="mono_input_field">
              <Input
                type="text"
                placeholder="Enter refer link"
                name="left_link"
                value={inputVal.leftVal}
                // ref={textAreaRef}
              />
              <Button type="button" onClick={()=>copyToClipboard("left")}>copy refer link</Button>
            </div>
            <div className="mono_input_field">
              <Input
                type="text"
                placeholder="Enter refer link"
                name="right_link"
                value={inputVal.rightVal}
              />
              <Button type="button" onClick={()=>copyToClipboard("right")}>copy refer link</Button>
            </div>
          </form>
        </CardLayout>
      </div>
      {/* today bonus */}
      <div className="mono_today_bonus_section card_row">
        <CardLayout
          style={{ backgroundColor: "#fff" }}
          className="mono_today_bonus_card"
        >
          <div className="card_heading">
            <h2>Today Bonus</h2>
          </div>
          <div className="mono_today_bonus_chart">
            <div className="mono_chart">
              <img src={chartImg} width="100%" alt="chart" />
            </div>
            <div className="mono_chart_content">
              <div className="mono_flex_content">
                {chart.map((d, i) => (
                  <div className="chart_data" key={i+1}>
                    <div className="data">
                      <svg
                        className="me-2"
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="15"
                          height="15"
                          rx="7.5"
                          fill={d.color}
                        ></rect>
                      </svg>
                      <span>{d.level}</span>
                    </div>
                    <div>
                      <span>
                        <h5>{d.earn}</h5>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </CardLayout>
        <SectionCommonTable
          wrapperClassName="mono_balance_card"
          cardStyle={{ backgroundColor: "#fff" }}
          sectionTableTitle="Balance (TRX)"
          table={<BalanceTable />}
        />
      </div>
      {/* team topup and add funds */}
      <div className="mono_team_topup_add_funds card_row">
        <SectionCommonTable
          wrapperClassName="mono_team_topup_card"
          cardStyle={{ backgroundColor: "#fff" }}
          sectionTableTitle="Team Topup"
          table={<TeamTopupTable />}
        />
        <CardLayout
          style={{ backgroundColor: "#fff" }}
          className="mono_add_funds_card"
        >
          <div className="mono_add_funds">
            <div className="card_heading">
              <h2>Add Funds</h2>
              <p>
                Payment Mode <span>*</span>
              </p>
            </div>
            <div className="mono_add_funds_item">
              <div className="payment_wallet">
                <div className="wallet">
                  <img src={tron} alt="trong" />
                  <h2>Tron</h2>
                </div>
                <div className="wallet">
                  <img src={bitcoin} alt="bitcoin" />
                  <h2>Bitcoin</h2>
                </div>
              </div>
              <div className="payment_wallet">
                <div className="wallet">
                  <img src={binance} alt="binance" />
                  <h2>Binance</h2>
                </div>
                <div className="wallet">
                  <img src={dogecoin} alt="dogecoin" />
                  <h2>Doge Coin</h2>
                </div>
              </div>
              <CustomLink href="/add-funds" className="wallet_address_link">
                view all
              </CustomLink>
            </div>
          </div>
        </CardLayout>
      </div>
      {/* my topup */}
      <div className="mono_my_topup card_row">
        <SectionCommonTable
          wrapperClassName="mono_my_topup_card"
          cardStyle={{ backgroundColor: "#fff" }}
          sectionTableTitle="My Topup"
          table={<MyTopupTable />}
        />
      </div>
      {/* auto pool and level income */}
      <div className="mono_auto_pool_level_income card_row">
        <SectionCommonTable
          wrapperClassName="mono_auto_pool_card"
          cardStyle={{ backgroundColor: "#fff" }}
          sectionTableTitle="Auto Pool"
          table={<AutoPoolTable />}
        />
        <SectionCommonTable
          wrapperClassName="mono_level_card"
          cardStyle={{ backgroundColor: "#fff" }}
          sectionTableTitle="Level Income"
          table={<LevelIncomTable />}
        />
      </div>
      {/* <UserDetails/> */}
    </div>
  );
};

export default HomePage;
